"use client";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export function ProductShowcaseSection() {
  return (
    <section
      id="home-product-showcase"
      className="py-24 bg-foreground/5"
      data-header-scheme="light"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Badge className="mb-6 bg-accent text-accent-foreground px-4 py-2 font-medium">
              Premium Quality
            </Badge>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-foreground mb-8 tracking-tight leading-tight">
              Concretta Microcement
            </h2>
            <p className="font-sans text-xl text-muted-foreground mb-8 leading-relaxed">
              Our premium microcement creates seamless, durable surfaces with an
              authentic concrete aesthetic. Perfect for floors, walls,
              countertops, and more.
            </p>
            <ul className="space-y-4 mb-10">
              <li className="flex items-center text-muted-foreground text-lg">
                <div className="w-3 h-3 bg-primary rounded-full mr-4 shrink-0" />
                Food-safe and non-toxic finish
              </li>
              <li className="flex items-center text-muted-foreground text-lg">
                <div className="w-3 h-3 bg-primary rounded-full mr-4 shrink-0" />
                Seamless application, no grout lines
              </li>
              <li className="flex items-center text-muted-foreground text-lg">
                <div className="w-3 h-3 bg-primary rounded-full mr-4 shrink-0" />
                Available in multiple colors and finishes
              </li>
            </ul>
            <Button size="lg" asChild>
              <Link href="/concretta">
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative overflow-hidden"
          >
            <div className="aspect-square bg-card rounded-lg overflow-hidden shadow-2xl relative">
              <Image
                src="/images/plaster-samples/concretta-microcement.png"
                alt="Concretta Microcement Product"
                fill
                priority
                sizes="(max-width: 768px) 100vw, 50vw"
                className="object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
